import { styled } from '@mui/material';

import { ReactNode } from 'react';

import { I18nResources, useI18n } from '@app-velocity/i18n';

import { Box } from '../Box';
import { Typography } from '../Typography';

export type InfoBoxProps = {
  title: I18nResources;
  description: I18nResources;
  content?: ReactNode;
};

const StyledDescription = styled(Typography)({
  color: 'var(--color-neutral-800)',
  fontWeight: 400,
  fontSize: 13,
  lineHeight: '18px',
});

const StyledTitle = styled(Typography)({
  fontSize: 18,
  lineHeight: '19px',
});

export const InfoBox = ({ title, description, content }: InfoBoxProps) => {
  const { t } = useI18n();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        padding: '16px',
        gap: '12px',
      }}
    >
      <StyledTitle variant="header">{t(title)}</StyledTitle>
      <StyledDescription>{t(description)}</StyledDescription>
      {content}
    </Box>
  );
};
